import { IoCall, IoVideocam } from "react-icons/io5";
import { FiArrowDownLeft, FiArrowUpRight } from "react-icons/fi";
import { CallRecord } from "../../../types/CallHistoryRes";
import { useAppSelector } from "../../../utils/hooks";
import TextTranslate from "../../../utils/TextTranslate";
import { resolveCallHistoryDirection } from "../../../utils/callHistoryPeer";

interface CallInCallHistoryProps {
  callData: CallRecord;
}

export default function CallInCallHistory({
  callData,
}: CallInCallHistoryProps) {
  const userData = useAppSelector((state) => state.userData);

  const call = callData?.Calls?.[0];
  if (!call) return null;

  const isVideo = call.call_type === "video";
  const direction = resolveCallHistoryDirection(callData, userData.user_id);
  const isOutgoing = direction === "outgoing";
  const isMissed = direction === "missed";

  let label = "";
  if (isMissed) {
    label = isVideo ? "Missed Video Call" : "Missed Audio Call";
  } else {
    label = isVideo
      ? isOutgoing
        ? "Outgoing Video Call"
        : "Incoming Video Call"
      : isOutgoing
        ? "Outgoing Audio Call"
        : "Incoming Audio Call";
  }

  const accent = isMissed ? "text-[#FF3B30]" : "text-lightText";

  return (
    <div className={`mt-0.5 flex items-center gap-1.5 text-[13px] ${accent}`}>
      <span className="relative inline-flex">
        {isVideo ? (
          <IoVideocam className="text-[15px]" />
        ) : (
          <IoCall className="text-[14px]" />
        )}
        <span className="absolute -bottom-0.5 -right-1.5 rounded-full bg-secondary">
          {isOutgoing ? (
            <FiArrowUpRight className="text-[10px]" />
          ) : (
            <FiArrowDownLeft className="text-[10px]" />
          )}
        </span>
      </span>
      <span>
        <TextTranslate text={label} />
      </span>
    </div>
  );
}
